/**
 * A module containing schema validation and documentation related to Schedules
 * @module ducks/schedule/schemas
 */

/** A JSONSchema definition for a manual zone run */
export const ManualZoneRunSchema = {
  /* eslint-disable camelcase */
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    duration: {
      // int32 duration = 1
      type: 'number'
    },
    zone_number: {
      // int32 zone_number = 3
      type: 'number'
    }
    /* eslint-enable camelcase */
  },
  required: ['duration', 'zone_number'],
  additionalProperties: false
}

export const UpdateBasicZoneSchema = {
  /* eslint-disable camelcase */
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    zone_id: {
      type: 'string'
    },
    name: {
      type: 'string'
    },
    enabled: {
      type: 'boolean'
    },
    soil_type: {
      type: 'object',
      value: 'string'
    },
    crop_type: {
      type: 'object',
      value: 'string'
    },
    nozzle_type: {
      type: 'object',
      value: 'string'
    },
    exposure_type: {
      type: 'object',
      value: 'string'
    },
    photo_bytes: {
      type: 'string'
    },
    slope_type: {
      type: 'object',
      value: 'string'
    }
  },
  required: ['zone_id'],
  additionalProperties: false
}

export const UpdateAdvancedZoneSchema = {
  /* eslint-disable camelcase */
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    zone_id: {
      type: 'string'
    },
    available_water_capacity: {
      type: 'string'
    },
    root_zone_depth: {
      type: 'string'
    },
    efficiency: {
      type: 'string'
    },
    area: {
      type: 'string'
    },
    flow_rate: {
      type: 'string'
    },
    crop_coefficient: {
      type: 'string'
    },
    managed_allowed_depletion: {
      type: 'string'
    }
  },
  required: ['zone_id'],
  additionalProperties: false
}

// oneof device_id OR zone_id
export const DismissAlertsRequest = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    /* eslint-disable camelcase */
    device_id: {
      type: 'string',
      minimum: 1
    },
    zone_id: {
      type: 'string',
      minimum: 1
    },
    alert_ids: {
      type: 'array',
      items: {
        type: ['string']
      }
    }
    /* eslint-enable camelcase */
  },
  required: ['alert_ids'],
  additionalProperties: false
}

// oneof device_id OR zone_id
export const UpdateZoneFlowRequest = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    /* eslint-disable camelcase */
    zone_id: {
      type: 'string',
      minimum: 1
    },
    flow_metering_enabled: { type: 'boolean' },
    flow_auto_shut_off_enabled: { type: 'boolean' },
    flow_high_threshold_pct: { type: 'number' },
    flow_low_threshold_pct: { type: 'number' },
    flow_baseline: { type: 'number' }
    /* eslint-enable camelcase */
  },
  required: ['zone_id', 'flow_metering_enabled'],
  additionalProperties: false
}

export const StartZoneCalibrationRequest = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    /* eslint-disable camelcase */
    zone_id: {
      type: 'string',
      minimum: 1
    }
    /* eslint-enable camelcase */
  },
  required: ['zone_id'],
  additionalProperties: false
}

export const StopZoneCalibrationRequest = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    /* eslint-disable camelcase */
    zone_id: {
      type: 'string',
      minimum: 1
    }
    /* eslint-enable camelcase */
  },
  required: ['zone_id'],
  additionalProperties: false
}
